/* eslint-disable react/jsx-closing-tag-location */
import React, { Component } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MaskedInput from 'react-text-mask';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

class MaskedInputField extends Component {

    setCursor = () => {
        const textfield = document.getElementById('phone-mask');
        textfield.value = textfield.value.replace(/[\u2000]/g, '');
    }

    TextMaskCustom = (props) => {
        const { ...other } = props;
        return (
            <MaskedInput
                {...other}
                id='phone-mask'
                keepCharPositions
                mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                onFocus={this.setCursor}
                placeholderChar={'\u2000'}
            />
        );
    }

    render () {
        return (
            <FormControl variant="outlined">
                <InputLabel
                    error={this.props.error}
                    htmlFor="component-outlined"
                    shrink={this.props.value}
                    required
                >
                    {this.props.label}
                </InputLabel>
                <OutlinedInput
                    error={this.props.error}
                    fullWidth
                    id="component-outlined"
                    inputComponent={this.TextMaskCustom}
                    label={this.props.label}
                    margin="normal"
                    name="phone"
                    notched={this.props.value}
                    onChange={this.props.handleChange}
                    value={this.props.value}
                    variant="outlined"
                />
                {
                    this.props.error
                        ? <FormHelperText id="text-red">
                            {this.props.error_text}
                        </FormHelperText> : ''
                }
            </FormControl>
        );
    }
}

export default MaskedInputField;
